import { apiService } from "../services/api.service";
import { authenticationService } from "../services/authentication.service";

export const expediciaController = {
    getForCreate,
    saveExpedicia,
    deleteExpedicia,
    vytvoritSpravu
};

function getForCreate(selectedBalikIds) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ selectedBalikIds })
    };
    return apiService.fetchApiRequest("api/Expedicia/GetForCreate", false, requestOptions);
}

function saveExpedicia(data) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(data)
    };
    return apiService.fetchApiRequest("api/Expedicia/Save", false, requestOptions);
}

function deleteExpedicia(idExpedicia) {
    const currentUser = authenticationService.currentUserValue;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ idExpedicia })
    };
    return apiService.fetchApiRequest("api/Expedicia/Delete", false, requestOptions);
}

function vytvoritSpravu(idExpedicia) {
    return apiService.fetchApiRequest(`api/Expedicia/VytvoritSpravu?idExpedicia=${idExpedicia}`);
}



// WEBPACK FOOTER //
// ./src/controllers/expedicia.controller.js